/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module NvocTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface NvOcPlugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "SliderSetting".
 */
export interface SliderSetting {
    /**
     * Minimum range value
     */
    min?: number;
    /**
     * Maximum range value
     */
    max?: number;
    /**
     * current value of the slider
     */
    current?: number;
    /**
     * Absolute value of the object
     */
    absolute?: number;
    /**
     * default value of the slider
     */
    default?: number;
    type?: Type;
    /**
     * whether slider is supported on the system or not
     */
    isSupported?: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "FanSetting".
 */
export interface FanSetting {
    /**
     * Fan index
     */
    index?: number;
    /**
     * Whether Fan is user contolled ot hardware controlled
     */
    autoPower?: boolean;
    /**
     * If fan control is Visible on current system
     */
    isVisible?: boolean;
    sliderSetting?: SliderSetting;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "OcConfig".
 */
export interface OcConfig {
    /**
     * true if background scan is enabled false otherwise
     */
    backgroundOcScannerEnabled?: boolean;
    /**
     * true GRD Oc is Enabled otherwise false
     */
    grdOcEnabled?: boolean;
    persitenceType?: PersitenceType;
    /**
     *  Indicates whether GRD OC is supported
     */
    grdOcSupported?: boolean;
    /**
     * Indicates whether background OC scanner is supported
     */
    backgroundOcScannerSupported?: boolean;
    /**
     * Indicates whether manual OC scanning is supported
     */
    manualOcScannerSupported?: boolean;
    /**
     * Indicates whether manual OC is supported
     */
    manualOcSupported?: boolean;
    /**
     * Indicates why OC feature is not supported, its bitwise Combined status of the unsupported state. 1-gpu not supported, 2-driver not supported
     */
    notSupportedStatus?: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GpuInfo".
 */
export interface GpuInfo {
    /**
     * Index of GPU
     */
    index?: number;
    /**
     * Name of the GPU
     */
    Name?: string;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "VFPoint".
 */
export interface VFPoint {
    /**
     * index of VF point
     */
    index?: number;
    /**
     * Voltage in uV
     */
    voltage?: number;
    /**
     * Frequency in kHz
     */
    frequency?: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "PerfProfile".
 */
export interface PerfProfile {
    profile: ProfileType;
    sliders: SliderSetting[];
    fanSettings: FanSetting[];
}
/**
 * One point of the graphics V/F curve.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCVfPointState".
 */
export interface ManualOCVfPointState {
    vfPointIndex: number;
    voltageUv: number;
    baseFrequencyKHz?: number;
    appliedFrequencyKHz: number;
    frequencyOffsetKHz: number;
    minFrequencyOffsetKHz: number;
    maxFrequencyOffsetKHz: number;
    /**
     * True when the driver lets the offset of this point be programmed
     */
    editable: boolean;
}
/**
 * Graphics and memory clock offset state.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCClockState".
 */
export interface ManualOCClockState {
    graphicsClockOffsetSupported: boolean;
    /**
     * False when the driver reports no base V/F curve; baseFrequencyKHz is then applied minus offset
     */
    graphicsBaseVfCurveAvailable?: boolean;
    graphicsVfCurve: ManualOCVfPointState[];
    /**
     * True when every editable point carries the same offset
     */
    graphicsVfOffsetsUniform?: boolean;
    /**
     * Present only when graphicsVfOffsetsUniform is true
     */
    graphicsUniformOffsetKHz?: number;
    graphicsUniformOffsetMinKHz?: number;
    graphicsUniformOffsetMaxKHz?: number;
    /**
     * Increment for graphics offsets (1000 = 1 MHz); drafts and stored profiles must be multiples, live third-party offsets are reported unrounded
     */
    graphicsOffsetStepKHz?: number;
    memoryClockOffsetSupported: boolean;
    /**
     * Memory clock offset in kHz as reported by the driver (no DDR multiplier)
     */
    memoryOffsetKHz?: number;
    memoryMinOffsetKHz?: number;
    memoryMaxOffsetKHz?: number;
    /**
     * Increment for the memory offset (1000 = 1 MHz)
     */
    memoryOffsetStepKHz?: number;
}
/**
 * Limiter values (only when isSupported): Voltage = % of over-voltage headroom (0-100), Power = % of board power limit, Temperature = degrees C target.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCLimiterState".
 */
export interface ManualOCLimiterState {
    type: ManualOcLimiterType;
    isSupported: boolean;
    min?: number;
    max?: number;
    current?: number;
    default?: number;
    step?: number;
}
/**
 * Scalar fan control state of one physical fan; percents 0-100.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCFanState".
 */
export interface ManualOCFanState {
    index: number;
    minPowerPercent: number;
    maxPowerPercent: number;
    autoPower: boolean;
    powerPercent: number;
    defaultAutoPower: boolean;
    defaultPowerPercent: number;
}
/**
 * Machine-wide startup restoration preference.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCStartupRestoreState".
 */
export interface ManualOCStartupRestoreState {
    /**
     * False when the GPU has no stable serial identity; the startup UI is hidden
     */
    supported: boolean;
    enabled: boolean;
    /**
     * Present only while enabled
     */
    profileId?: number;
}
/**
 * Startup-restore view (no boot id, registry path, raw status); set when the GPU has a serial-backed id and a restore is pending, active, done/failed.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCStartupRecoveryState".
 */
export interface ManualOCStartupRecoveryState {
    status: ManualOcStartupRecoveryStatus;
    /**
     * True exactly while status is Failed and the one-time message has not been acknowledged
     */
    messagePending: boolean;
    reason?: ManualOcStartupRecoveryReason;
    /**
     * Domains the driver rejected when the reason is ApplyFailed
     */
    domainIds?: ManualOcStartupRecoveryDomain[];
}
/**
 * Presence summary of one profile slot (no validation at page entry).
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileSlotSummary".
 */
export interface ManualOCProfileSlotSummary {
    slot: number;
    isSaved: boolean;
}
/**
 * Aggregate live Manual OC state.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCState".
 */
export interface ManualOCState {
    accessState: ManualOcAccessState;
    ownership: ManualOcOwnership;
    clock: ManualOCClockState;
    limiters: ManualOCLimiterState[];
    fanControlSupported: boolean;
    fans: ManualOCFanState[];
    /**
     * Present when fanControlSupported: every fan carries the same mode and target
     */
    fansSynchronized?: boolean;
    profileStorageAvailable: boolean;
    profileStorageFailure: ManualOcProfileStorageFailure;
    appliedProfile?: ManualOcAppliedProfile;
    startupRestore: ManualOCStartupRestoreState;
    slots: ManualOCProfileSlotSummary[];
}
/**
 * Offset of one editable graphics V/F point in kHz.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileVfPointOffset".
 */
export interface ManualOCProfileVfPointOffset {
    vfPointIndex: number;
    frequencyOffsetKHz: number;
}
/**
 * Target of one supported limiter (units as ManualOCLimiterState).
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileLimiter".
 */
export interface ManualOCProfileLimiter {
    type: ManualOcLimiterType;
    value: number;
}
/**
 * Scalar fan target of one physical fan.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileFan".
 */
export interface ManualOCProfileFan {
    index: number;
    autoPower: boolean;
    powerPercent: number;
}
/**
 * Complete supported-domain snapshot.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileDraft".
 */
export interface ManualOCProfileDraft {
    graphicsVfOffsets: ManualOCProfileVfPointOffset[];
    memoryOffsetKHz?: number;
    limiters: ManualOCProfileLimiter[];
    fans: ManualOCProfileFan[];
}
/**
 * A saved profile loaded from one slot.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfile".
 */
export interface ManualOCProfile {
    slot: number;
    draft: ManualOCProfileDraft;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetFeatureSupportStateReturn".
 */
export interface GetFeatureSupportStateReturn {
    /**
     * Defines if OverClocking is supported
     */
    supported: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetManualOCLimitsParameters".
 */
export interface GetManualOCLimitsParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetManualOCLimitsReturn".
 */
export interface GetManualOCLimitsReturn {
    sliders: SliderSetting[];
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetLastOcScanResultsParameters".
 */
export interface GetLastOcScanResultsParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetLastOcScanResultsReturn".
 */
export interface GetLastOcScanResultsReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetLastIncompleteOcScannerResultsParameters".
 */
export interface GetLastIncompleteOcScannerResultsParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetLastIncompleteOcScannerResultsReturn".
 */
export interface GetLastIncompleteOcScannerResultsReturn {
    /**
     * true if successfully set otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetFanSettingsParameters".
 */
export interface GetFanSettingsParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetFanSettingsReturn".
 */
export interface GetFanSettingsReturn {
    fanSettings: FanSetting[];
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "OcScanStatusUpdatesNotificationsReturn".
 */
export interface OcScanStatusUpdatesNotificationsReturn {
    /**
     * Gpu index for which this notification is
     */
    gpuId?: number;
    /**
     * Progress update or Completion event
     */
    type?: number;
    /**
     * Percent completed
     */
    percentComplete?: number;
    /**
     * Indicates Bitwise Combined status of the scan. 1-scan in progress, 2-No Scan in progress, 4-Completed successfully, 8-Cancelled, 16-Internal Error, 32-No result available
     */
    completionStatus?: number;
    /**
     * completion Timestamp
     */
    completionTime?: number;
    /**
     * Applied memory offset
     */
    memoryOcOffsetMhz?: number;
    /**
     * Applied Gpu clock offset
     */
    averageGpuClockOffsetMhz?: number;
    /**
     * Indicates if result is stable or not. Show Last scan result only when it is stable
     */
    stable?: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetOCConfigParameters".
 */
export interface GetOCConfigParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetOCConfigReturn".
 */
export interface GetOCConfigReturn {
    /**
     * true if success otherwise false
     */
    result: boolean;
    ocConfig?: OcConfig;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetGpuInfoReturn".
 */
export interface GetGpuInfoReturn {
    /**
     * true if success otherwise false
     */
    result: boolean;
    gpus: GpuInfo[];
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetOCAdminConsentReturn".
 */
export interface GetOCAdminConsentReturn {
    /**
     * Whether the active-user lookup and consent read completed
     */
    result: boolean;
    /**
     * Return value which inform if admin consent is present or not; false when result is false
     */
    adminConsent: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "SetOCAdminConsentParameters".
 */
export interface SetOCAdminConsentParameters {
    adminConsent: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "SetOCAdminConsentReturn".
 */
export interface SetOCAdminConsentReturn {
    /**
     * false if there is any error otherwise true
     */
    result: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "powerStatusNotificationReturn".
 */
export interface powerStatusNotificationReturn {
    powerStatus?: PowerStatus;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetVFPointsParameters".
 */
export interface GetVFPointsParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetVFPointsReturn".
 */
export interface GetVFPointsReturn {
    baseVfPoints?: VFPoint[];
    offsetVfPoints?: VFPoint[];
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "EnableCurrentVFPointNotificationParameters".
 */
export interface EnableCurrentVFPointNotificationParameters {
    uiGpuId: number;
    /**
     * whether to enable perf stats notification
     */
    isEnable: boolean;
    /**
     * polling interval in milisec
     */
    intervalMS: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "EnableCurrentVFPointNotificationReturn".
 */
export interface EnableCurrentVFPointNotificationReturn {
    /**
     * true if successfully stated otherwise false
     */
    result: boolean;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "CurrentVFPointNotificationReturn".
 */
export interface CurrentVFPointNotificationReturn {
    /**
     * Gpu index for which this notification is
     */
    gpuId?: number;
    /**
     * current voltage
     */
    voltage?: number;
    /**
     * graphics clock frequency in KHz
     */
    frequency?: number;
    /**
     * memory clock frequency in KHz
     */
    memoryFrequency?: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetPerfProfilesParameters".
 */
export interface GetPerfProfilesParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetPerfProfilesReturn".
 */
export interface GetPerfProfilesReturn {
    CurrentProfile: ProfileType;
    profiles: PerfProfile[];
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetManualOCStateParameters".
 */
export interface GetManualOCStateParameters {
    uiGpuId: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetManualOCStateReturn".
 */
export interface GetManualOCStateReturn {
    /**
     * True when the required live driver state is usable and state is present
     */
    result: boolean;
    failure: ManualOcProfileFailure;
    state?: ManualOCState;
    startupRecovery?: ManualOCStartupRecoveryState;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetManualOCProfileParameters".
 */
export interface GetManualOCProfileParameters {
    uiGpuId: number;
    slot: number;
}
/**
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "GetManualOCProfileReturn".
 */
export interface GetManualOCProfileReturn {
    result: boolean;
    failure: ManualOcProfileFailure;
    profile?: ManualOCProfile;
}

/**
 * Type of the slider
 */
export enum Type {
    Unknown = 0,
    GpuClock = 1,
    MemoryClock = 2,
    Voltage = 3,
    Power = 4,
    Temperature = 5,
    Fan = 6
}
/**
 * Type of persistence currently on the system
 */
export enum PersitenceType {
    None = 0,
    ManualOc = 1,
    AutomaticOc = 2
}
/**
 * Type of the perf profile
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ProfileType".
 */
export enum ProfileType {
    Default = 0,
    Custom = 1,
    Silent = 2,
    MaxPerf = 3
}
/**
 * Failure code shared by the Manual OC state and profile commands.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileFailure".
 */
export enum ManualOcProfileFailure {
    None = 0,
    ConsentDenied = 1,
    AutomaticOCActive = 2,
    DriverStateUnavailable = 3,
    InvalidSlot = 4,
    SlotEmpty = 5,
    SnapshotInvalid = 6,
    ProfileIncompatible = 7,
    ProfileStorageError = 8,
    HardwareApplyFailed = 9,
    LiveStateMismatch = 10,
    ProfileIdentityUnavailable = 11,
    StartupRestoreUnsupported = 12,
    InvalidGpu = 13,
    InvalidRequest = 14
}
/**
 * Limiter identity; values match SliderSetting.type (3 Voltage, 4 Power, 5 Temperature).
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCLimiterType".
 */
export enum ManualOcLimiterType {
    Voltage = 3,
    Power = 4,
    Temperature = 5
}
/**
 * Tuning domain on the wire (0 Graphics, 1 Memory, 2 Voltage, 3 Power, 4 Temperature, 5 Fan).
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCApplyDomain".
 */
export enum ManualOcApplyDomain {
    GraphicsVf = 0,
    MemoryClock = 1,
    VoltageLimit = 2,
    PowerLimit = 3,
    TemperatureLimit = 4,
    Fan = 5
}
/**
 * Driver OC ownership at the time of this read.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCOwnership".
 */
export enum ManualOcOwnership {
    None = 0,
    ManualOc = 1,
    AutomaticOc = 2,
    Unknown = 3
}
/**
 * 0 controls usable; 1 state readable but the consent-gated Manual OC mutation operations need the current user admin consent; 2 the GPU or driver has no Manual OC.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCAccessState".
 */
export enum ManualOcAccessState {
    Available = 0,
    ConsentRequired = 1,
    Unsupported = 2
}
/**
 * Profile-storage status of the aggregate state read: 0 none, 8 the profile store could not be read, 11 the GPU has no usable identity. Values follow ManualOCProfileFailure.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCProfileStorageFailure".
 */
export enum ManualOcProfileStorageFailure {
    None = 0,
    ProfileStorageError = 8,
    ProfileIdentityUnavailable = 11
}
/**
 * Classification of the live state: 0 Default, 1..5 the saved slot that matches, 6 Custom; omitted while Automatic Tuning (or an unknown owner) controls the GPU.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCAppliedProfile".
 */
export enum ManualOcAppliedProfile {
    Default = 0,
    Profile1 = 1,
    Profile2 = 2,
    Profile3 = 3,
    Profile4 = 4,
    Profile5 = 5,
    Custom = 6
}
/**
 * Normalized reason for a failed startup restoration; present only while a failure is recorded.
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCStartupRecoveryReason".
 */
export enum ManualOcStartupRecoveryReason {
    ApplyFailed = 0,
    ReadbackFailed = 1,
    ReadbackMismatch = 2,
    StabilityCheckFailed = 3,
    StartupInterrupted = 4,
    GpuUnavailable = 5,
    ProfileInvalid = 6,
    RecoveryStateInvalid = 7,
    TuningConflict = 8,
    UnknownFailure = 9
}
/**
 * Failed startup-restore domain: 1 core V/F, 2 memory, 3 voltage limit, 4 power limit, 5 temperature limit, 6 fan (1-based, unlike ManualOCApplyDomain).
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCStartupRecoveryDomain".
 */
export enum ManualOcStartupRecoveryDomain {
    CoreVf = 1,
    MemoryVram = 2,
    VoltageLimit = 3,
    PowerLimit = 4,
    TemperatureLimit = 5,
    Fan = 6
}
/**
 * Startup restore: 0 waiting for next boot, 1 applying, 2 observing after apply, 3 done this boot, 4 failed (message pending), 5 failed (message shown).
 *
 * This interface was referenced by `NvOcPlugin`'s JSON-Schema
 * via the `definition` "ManualOCStartupRecoveryStatus".
 */
export enum ManualOcStartupRecoveryStatus {
    WaitingForNextBoot = 0,
    Applying = 1,
    Monitoring = 2,
    Completed = 3,
    Failed = 4,
    FailureShown = 5
}
/**
 * power status. 0-AC, 1-DC
 */
export enum PowerStatus {
    AC = 0,
    DC = 1,
    UPS_LIKE = 2,
    Unknown = 3
}


}
